import React from 'react'
import PropTypes from 'prop-types'
import STRINGS from 'utils/strings'
import { formatMinutesAsDuration } from 'utils/time'
import { normalizeSchedules } from '../utils/schedulePreviewHelpers'

const SaveResumePreview = ({ instrument, confirmedSchedules }) => {
  const schedules = [
    ...normalizeSchedules(instrument?.metadata?.schedule),
    ...normalizeSchedules(confirmedSchedules),
  ]
  const schedule = schedules.find(item => item?.timeout_window?.draft) || schedules[0] || {}
  const { timeout_window } = schedule
  const { draft } = timeout_window || {}
  const { value: draftValue } = draft || {}

  if (!draft) {
    return (
      <div className='save-resume-preview'>
        <p>
          <span>{STRINGS.saveResumeQuestion}</span>
        </p>
        <p>{STRINGS.saveResumeOption1}</p>
      </div>
    )
  }

  const formatted = formatMinutesAsDuration(draftValue)

  return (
    <div className='save-resume-preview'>
      <p>
        <span>{STRINGS.saveResumeQuestion}</span>
      </p>
      <p>
        {STRINGS.saveResumeOption2} {formatted}
      </p>
    </div>
  )
}

SaveResumePreview.propTypes = {
  confirmedSchedules: PropTypes.arrayOf(PropTypes.object),
  instrument: PropTypes.shape({
    metadata: PropTypes.shape({
      schedule: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    }),
  }),
}

export default SaveResumePreview
